/* DisabledMenuPaths.ts */

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";

export const DisabledMenuPaths = [
  Paths.HOME,
  Paths.AI_ASSISTANT,
  Paths.GLOSSARY,
  Paths.IMPRINT,
];
